		   // Para documentação completa sobre API, includindo exemplos de códigos, visite https://wix.to/94BuAAs
// Para documentação completa sobre API, includindo exemplos de códigos, visite https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});